/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { Method,prepare,QueryStringArrayFormat,RequestBodyType,ResponseBodyType } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig,RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../../../utils/http';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult,
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (
      requestData: TRequestData,
      ...args: RequestFunctionRestArgs<typeof request>
    ) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = 'https://yapi.tratao.com/mock/109' as any;
const devUrl_0_0_0_0 = '' as any;
const prodUrl_0_0_0_0 = '' as any;
const dataKey_0_0_0_0 = undefined as any;

/**
 * 接口 [商户详情↗](https://yapi.tratao.com/project/109/interface/api/6997) 的 **请求类型**
 *
 * @分类 [商户管理↗](https://yapi.tratao.com/project/109/interface/api/cat_1423)
 * @标签 `商户管理`
 * @请求头 `GET /api/merchant/info/get`
 * @更新时间 `2025-04-17 15:07:03`
 */
export interface GetApiMerchantInfoGetRequest {}

/**
 * 接口 [商户详情↗](https://yapi.tratao.com/project/109/interface/api/6997) 的 **返回类型**
 *
 * @分类 [商户管理↗](https://yapi.tratao.com/project/109/interface/api/cat_1423)
 * @标签 `商户管理`
 * @请求头 `GET /api/merchant/info/get`
 * @更新时间 `2025-04-17 15:07:03`
 */
export interface GetApiMerchantInfoGetResponse {
  data?: {
    /**
     * 公司注册地址
     */
    address?: string;
    /**
     * 货贸-PI
     */
    goodsPi?: {
      /**
       * 文件名
       */
      name?: string;
      /**
       * 时间
       */
      time?: string;
      /**
       * uid
       */
      uid?: string;
      /**
       * url
       */
      url?: string;
    }[];
    /**
     * 物流单
     */
    goodsLogistics?: {
      /**
       * 文件名
       */
      name?: string;
      /**
       * 时间
       */
      time?: string;
      /**
       * uid
       */
      uid?: string;
      /**
       * url
       */
      url?: string;
    }[];
    /**
     * 服务合同
     */
    serviceContract?: {
      /**
       * 文件名
       */
      name?: string;
      /**
       * 时间
       */
      time?: string;
      /**
       * uid
       */
      uid?: string;
      /**
       * url
       */
      url?: string;
    }[];
    /**
     * 薪酬税单
     */
    salaryPayroll?: {
      /**
       * 文件名
       */
      name?: string;
      /**
       * 时间
       */
      time?: string;
      /**
       * uid
       */
      uid?: string;
      /**
       * url
       */
      url?: string;
    }[];
    /**
     * 赡家关系证明
     */
    familySupportProof?: {
      /**
       * 文件名
       */
      name?: string;
      /**
       * 时间
       */
      time?: string;
      /**
       * uid
       */
      uid?: string;
      /**
       * url
       */
      url?: string;
    }[];
    enterpriseStaffList?: {
      /**
       * 文件名
       */
      name?: string;
      /**
       * 时间
       */
      time?: string;
      /**
       * uid
       */
      uid?: string;
      /**
       * url
       */
      url?: string;
    }[];
    enterpriseStaffContact?: {
      /**
       * 文件名
       */
      name?: string;
      /**
       * 时间
       */
      time?: string;
      /**
       * uid
       */
      uid?: string;
      /**
       * url
       */
      url?: string;
    }[];
    /**
     * 反洗钱政策
     */
    amlPolicy?: {
      /**
       * 文件名
       */
      name?: string;
      /**
       * 时间
       */
      time?: string;
      /**
       * uid
       */
      uid?: string;
      /**
       * url
       */
      url?: string;
    }[];
    /**
     * 公司周年申报表
     */
    annualReturn?: {
      /**
       * 文件名
       */
      name?: string;
      /**
       * 时间
       */
      time?: string;
      /**
       * uid
       */
      uid?: string;
      /**
       * url
       */
      url?: string;
    }[];
    /**
     * 公司章程
     */
    articlesOfAssociation?: {
      /**
       * 文件名
       */
      name?: string;
      /**
       * 时间
       */
      time?: string;
      /**
       * uid
       */
      uid?: string;
      /**
       * url
       */
      url?: string;
    }[];
    /**
     * 开立账户董事会决议
     */
    boardResolution?: {
      /**
       * 文件名
       */
      name?: string;
      /**
       * 时间
       */
      time?: string;
      /**
       * uid
       */
      uid?: string;
      /**
       * url
       */
      url?: string;
    }[];
    /**
     * 公司注册文件
     */
    businessLicense?: {
      /**
       * 文件名
       */
      name?: string;
      /**
       * 时间
       */
      time?: string;
      /**
       * uid
       */
      uid?: string;
      /**
       * url
       */
      url?: string;
    }[];
    /**
     * 商业登记证
     */
    businessRegistrationCert?: {
      /**
       * 文件名
       */
      name?: string;
      /**
       * 时间
       */
      time?: string;
      /**
       * uid
       */
      uid?: string;
      /**
       * url
       */
      url?: string;
    }[];
    /**
     * 商户号
     */
    channel?: string;
    /**
     * 公司名称
     */
    companyName?: string;
    /**
     * 官网
     */
    companyWeb?: string;
    /**
     * 合规官个人简历
     */
    complianceOfficerResume?: {
      /**
       * 文件名
       */
      name?: string;
      /**
       * 时间
       */
      time?: string;
      /**
       * uid
       */
      uid?: string;
      /**
       * url
       */
      url?: string;
    }[];
    /**
     * 国家
     */
    country?: string;
    /**
     * 充值币种
     */
    depositCurrencies?: string[];
    /**
     * 邮箱
     */
    email?: string;
    /**
     * 审核失败原因
     */
    failMessage?: string;
    /**
     * 提交步骤，从 1 开始
     */
    fillStep?: number;
    /**
     * 是否禁用
     */
    forbidden?: boolean;
    /**
     * 禁止下单
     */
    forbiddenOrder?: boolean;
    /**
     * 商户 id
     */
    id?: string;
    /**
     * 渠道号
     */
    inChannel?: string;
    /**
     * 行业
     */
    industry?: string;
    /**
     * 持牌信息
     */
    mtoLicensePlate?: {
      /**
       * 文件名
       */
      name?: string;
      /**
       * 时间
       */
      time?: string;
      /**
       * uid
       */
      uid?: string;
      /**
       * url
       */
      url?: string;
    }[];
    /**
     * 商户名称
     */
    name?: string;
    /**
     * NDA 签署
     */
    ndaSign?: string;
    /**
     * 客户签署 NDA 状态：processing, completed, failed
     */
    ndaSignStatus?: string;
    /**
     * 公司办公场地照片
     */
    officePhotos?: {
      /**
       * 文件名
       */
      name?: string;
      /**
       * 时间
       */
      time?: string;
      /**
       * uid
       */
      uid?: string;
      /**
       * url
       */
      url?: string;
    }[];
    /**
     * 调查文件一
     */
    question1?: string;
    /**
     * 问卷 1 预审核信息
     */
    question1PreviewMessage?: string;
    /**
     * 问卷 1 预审核状态：processing, passed, failed
     */
    question1PreviewStatus?: string;
    /**
     * 客户签署 NDA 状态：processing, completed, failed
     */
    question1SignStatus?: string;
    /**
     * 调查文件二
     */
    question2?: string;
    /**
     * 问卷 2 预审核信息
     */
    question2PreviewMessage?: string;
    /**
     * 问卷 2 预审核状态：processing, passed, failed
     */
    question2PreviewStatus?: string;
    /**
     * 客户签署 NDA 状态：processing, completed, failed
     */
    question2SignStatus?: string;
    /**
     * 调查文件三
     */
    question3?: string;
    /**
     * 问卷辅助说明文件
     */
    questionAttachment?: {
      /**
       * 文件名
       */
      name?: string;
      /**
       * 时间
       */
      time?: string;
      /**
       * uid
       */
      uid?: string;
      /**
       * url
       */
      url?: string;
    }[];
    /**
     * 公司注册日期
     */
    registrationDate?: string;
    /**
     * 公司注册码
     */
    registrationNumber?: string;
    /**
     * 备注
     */
    remark?: string;
    /**
     * 审核步骤: 1, 2, 3
     */
    reviewStep?: number;
    /**
     * 独立第三方风险评估报告
     */
    riskAssessmentReport?: {
      /**
       * 文件名
       */
      name?: string;
      /**
       * 时间
       */
      time?: string;
      /**
       * uid
       */
      uid?: string;
      /**
       * url
       */
      url?: string;
    }[];
    /**
     * 股权架构图
     */
    shareholdingStructureMaterial?: {
      /**
       * 文件名
       */
      name?: string;
      /**
       * 时间
       */
      time?: string;
      /**
       * uid
       */
      uid?: string;
      /**
       * url
       */
      url?: string;
    }[];
    /**
     * 商户开户状态
     */
    state?: 'onboarding' | 'complete' | 'reject';
    transactionMode?: {
      /**
       * 充值
       */
      deposit?: string[];
      /**
       * 换汇
       */
      exchange?: string[];
      /**
       * 下发
       */
      transfer?: string[];
    };
    /**
     * 下发币种
     */
    transferCurrency?: string;
    /**
     * 商户类型
     */
    type?: 'merchant' | 'agent' | 'agentCustomer';
    /**
     * UBO 身份证明文件
     */
    uboCredential?: {
      /**
       * 文件名
       */
      name?: string;
      /**
       * 时间
       */
      time?: string;
      /**
       * uid
       */
      uid?: string;
      /**
       * url
       */
      url?: string;
    }[];
    /**
     * UBO 信息文件
     */
    uboInfoMaterial?: {
      /**
       * 文件名
       */
      name?: string;
      /**
       * 时间
       */
      time?: string;
      /**
       * uid
       */
      uid?: string;
      /**
       * url
       */
      url?: string;
    }[];
    /**
     * 用户 id
     */
    userId?: string;
    logo: string;
    themeColor: string;
    termsAndConditions: {
      title: string;
      content: string;
    };
    privacyPolicy: string;
    /**
     * 手续费币种
     */
    feeCurrency?: string;
    /**
     * 手续费金额
     */
    feeAmount?: number;
    /**
     * 各模式手续费配置
     */
    transactionModeFeeMap?: {};
    productList?: string[];
    businessArea?: string[];
    version?: string;
    ownLicense?: boolean;
    materialSetting?: string[];
  };
  message?: string;
  status?: string;
}

/**
 * 接口 [商户详情↗](https://yapi.tratao.com/project/109/interface/api/6997) 的 **请求配置的类型**
 *
 * @分类 [商户管理↗](https://yapi.tratao.com/project/109/interface/api/cat_1423)
 * @标签 `商户管理`
 * @请求头 `GET /api/merchant/info/get`
 * @更新时间 `2025-04-17 15:07:03`
 */
type GetApiMerchantInfoGetRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.tratao.com/mock/109',
    '',
    '',
    '/api/merchant/info/get',
    undefined,
    string,
    string,
    true
  >
>;

/**
 * 接口 [商户详情↗](https://yapi.tratao.com/project/109/interface/api/6997) 的 **请求配置**
 *
 * @分类 [商户管理↗](https://yapi.tratao.com/project/109/interface/api/cat_1423)
 * @标签 `商户管理`
 * @请求头 `GET /api/merchant/info/get`
 * @更新时间 `2025-04-17 15:07:03`
 */
const getApiMerchantInfoGetRequestConfig: GetApiMerchantInfoGetRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/api/merchant/info/get',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getApiMerchantInfoGet',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [商户详情↗](https://yapi.tratao.com/project/109/interface/api/6997) 的 **请求函数**
 *
 * @分类 [商户管理↗](https://yapi.tratao.com/project/109/interface/api/cat_1423)
 * @标签 `商户管理`
 * @请求头 `GET /api/merchant/info/get`
 * @更新时间 `2025-04-17 15:07:03`
 */
export const getApiMerchantInfoGet = /*#__PURE__*/ (
  requestData?: GetApiMerchantInfoGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GetApiMerchantInfoGetResponse>(
    prepare(getApiMerchantInfoGetRequestConfig, requestData),
    ...args,
  );
};

getApiMerchantInfoGet.requestConfig = getApiMerchantInfoGetRequestConfig;

/* prettier-ignore-end */
